import {
    getDefaultTrialCalendarFilter,
    ITrialCalendarFilter,
    TTrialLessonStatus,
    TTrialLessonLostType,
    TTutorGender,
} from "../../../entities/trialLesson";

const ID_FIELDS: Array<keyof Pick<ITrialCalendarFilter, 'tgAccountIds' | 'userIds' | 'tagIds'>> = [
    'tgAccountIds',
    'userIds',
    'tagIds',
]

const TRIAL_STATUSES = new Set<TTrialLessonStatus>(getDefaultTrialCalendarFilter().statuses)
const LOST_TYPES = new Set<TTrialLessonLostType>([
    'TRIAL_LESSON_LOST_TYPE_BEFORE_TRIAL',
])
const TUTOR_GENDERS = new Set<TTutorGender>([
    'TUTOR_GENDER_MALE',
    'TUTOR_GENDER_FEMALE',
    'TUTOR_GENDER_ANY',
])

export const getTrialCalendarFilterFromSearchParams = (searchParams: URLSearchParams): ITrialCalendarFilter => {
    const lostTypes = searchParams.getAll('lostTypes')
        .filter((type): type is TTrialLessonLostType => LOST_TYPES.has(type as TTrialLessonLostType))
    const statuses = searchParams
        .getAll('statuses')
        .filter((status): status is TTrialLessonStatus => TRIAL_STATUSES.has(status as TTrialLessonStatus))

    return {
        tgAccountIds: searchParams.getAll('tgAccountIds'),
        userIds: searchParams.getAll('userIds'),
        tagIds: searchParams.getAll('tagIds'),
        statuses: statuses.length || lostTypes.length ? statuses : getDefaultTrialCalendarFilter().statuses,
        lostTypes,
        tutorGender: TUTOR_GENDERS.has(searchParams.get('tutorGender') as TTutorGender)
            ? searchParams.get('tutorGender') as TTutorGender
            : getDefaultTrialCalendarFilter().tutorGender,
        requiredDurationSlots: Math.max(1, Number(searchParams.get('requiredDurationSlots')) || 1),
    }
}

export const getSearchParamsFromTrialCalendarFilter = (filter: ITrialCalendarFilter): URLSearchParams => {
    const searchParams = new URLSearchParams()

    ID_FIELDS.forEach(field => {
        filter[field].forEach(id => searchParams.append(field, id))
    })

    const defaultStatuses = getDefaultTrialCalendarFilter().statuses
    const hasDefaultStatuses = filter.statuses.length === defaultStatuses.length
        && defaultStatuses.every(status => filter.statuses.includes(status))

    if(!hasDefaultStatuses || filter.lostTypes?.length){
        filter.statuses.forEach(status => searchParams.append('statuses', status))
    }
    filter.lostTypes?.forEach(type => searchParams.append('lostTypes', type))
    if(filter.tutorGender !== 'TUTOR_GENDER_UNSPECIFIED'){
        searchParams.set('tutorGender', filter.tutorGender)
    }
    if(filter.requiredDurationSlots > 1){
        searchParams.set('requiredDurationSlots', String(filter.requiredDurationSlots))
    }
    return searchParams
}
